<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Статьи
    </h1>
    <CommonComplexFiltering
      v-if="false"
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      :filters-active="filters"
    />
    <!-- :sources-list="sources?.data?.value" -->
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="(article, index) in articles?.data?.value?.data"
        :key="`${article.id}_${index}`"
        :data="article"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        disable-announce
      />
    </div>

    <BaseThePagination :entity="articles" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="articles.hasNextPage.value"
        text="Показать еще"
        @click="articles.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
    category: route.query?.category,
    startCentury: route.query?.startCentury,
    endCentury: route.query?.endCentury,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
const { articles, resetPage } = useArticles({ filters, per_page: 9, page });
const { rubrics } = useArticlesCategories();

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  {
    id: 1,
    label: 'Обсуждаемые',
    value: 'comments',
    icon: 'chat-circle',
  },
  { id: 2, label: 'Популярные', value: 'views', icon: 'eye' },
  { id: 3, label: 'Любимые', value: 'likes', icon: 'like' },
];

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'История РФ: статьи для школьников и студентов | Читать на Федеральном портале Истории России',
  ),
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
